import './FeedbackSelect.scss'

import React, { Component } from 'react'
import Select from 'react-select'

export default class FeedbackSelect extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { label, value, multi, clearable, backspaceRemoves, onChange, onBlur, options, disabled, errorMsg, warningMsg, dataTestId } = this.props

    return (
      <div className='FeedbackSelect form-group' data-testid={dataTestId || label}>
        <Select
          label={label}
          value={value}
          multi={multi}
          clearable={clearable}
          backspaceRemoves={backspaceRemoves}
          onChange={onChange}
          onBlur={onBlur}
          options={options}
          disabled={disabled}
          className={errorMsg && 'FeedbackSelect__select-error' || warningMsg && 'FeedbackSelect__select-warning'}
        />
        <div className='FeedbackSelect__error'>
          {errorMsg ? (<span className='FeedbackSelect__error--message'>{errorMsg}</span>) : null}
          {warningMsg ? (<span className='FeedbackSelect__warning--message'>{warningMsg}</span>) : null}
        </div>
      </div>
    )
  }
}

